<template>
    <div class="project-introduction">
      <!-- <div class="content">
      </div> -->
      <div class="centerContent">
        <el-breadcrumb separator="/">
  <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
  <el-breadcrumb-item :to="{ path: '/Notice' }">通知公告</el-breadcrumb-item>
  <el-breadcrumb-item>{{noticeDetail.title}}</el-breadcrumb-item>
</el-breadcrumb>
<div class="newsListContent">
    <div class="newsDetailContent">
        <div class="newsDetailTitle">
          {{noticeDetail.title}}
        </div>
        <div class="newsDetailDate">
          {{noticeDetail.add_date}}
        </div>
        <div class="newsDetailContentHtml" v-html="noticeDetail.profile">
        </div>
    </div>
</div>
      </div>
    </div>
  </template>
  
<script>

export default {
  name: "NoticeDetail",
  data() {
    return {
      noticeDetail: {}
    }
  },
  created() {
    // 获取路由参数 id
    const id = this.$route.query.id
    console.log('通知公告ID:', id)
    this.getNoticeDetail(id)
  },
  methods: {
    getNoticeDetail(id){
      this.$API.getNoticeDetail(id).then(res => {
        this.noticeDetail = res.data
      })
    }
  }

};
</script>
  
  <style scoped>
  .newsDetailDate{
    margin-top: 20px;
    text-align: center;
    color: #999;
    margin-left: auto;
    margin-right: auto;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 20px;
  }
  .newsDetailTitle{
    font-size: 32px;
    text-align: center;
    color: #5c5c5c;
  }

  ::v-deep .newsDetailContentHtml img{
        max-width: 100%;
        height: auto;
        display: block;
        object-fit: contain;
  }
 .newsDetailContent{
      padding: 30px 50px;

   }
  .newsListContent{
    background: #fff;
    margin-top: 30px;
  }
  ::v-deep .is-link{
    color: #00000073;
  }
  .centerContent{
    width: 1200px;
    margin: 0 auto;
    padding-top: 30px;
    padding-bottom: 30px;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-direction: column;
    flex-direction: column;
    -webkit-justify-content: center;
    justify-content: center;
    background-color: #eeeeee;
  }
  .project-introduction {
    background: #eeeeee;
  }
.content{
    position: relative;
    z-index: 2;
    overflow: hidden;
    background: #000;
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: center;
    justify-content: center;
    background-image: url('../../assets/noticeBanner.png');
    background-repeat: no-repeat;
    background-position: 50%;
    width: 100%;
    min-height: 350px;
    -webkit-align-items: center;
    align-items: center;
}
  </style>
  